import { render, staticRenderFns } from "./BusinessBackCardManage.vue?vue&type=template&id=77d632d1&scoped=true&"
import script from "./BusinessBackCardManage.vue?vue&type=script&lang=js&"
export * from "./BusinessBackCardManage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessBackCardManage.vue?vue&type=style&index=0&id=77d632d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d632d1",
  null
  
)

export default component.exports